import { html } from '../utils';
// @link https://docs.gravityforms.com/gform_confirmation_loaded/
export class FormCta {
    openButton;
    closeButton;
    content;
    open;
    constructor(openButton, closeButton, content) {
        this.openButton = openButton;
        this.closeButton = closeButton;
        this.content = content;
        this.open = false;
        // Bind click
        const handleClick = this.handleClick.bind(this);
        this.openButton?.addEventListener('click', handleClick);
        this.closeButton?.addEventListener('click', handleClick);
    }
    handleClick() {
        this.updateGlobalClasses();
    }
    updateGlobalClasses() {
        const footer = document.querySelector('.footer-cta');
        if (this.open) {
            this.content.classList.add('animate-fade-out-down-10', 'pointer-events-none');
            this.content.classList.remove('animate-fade-in-up-25');
            footer?.classList.remove('animate-fade-out-down-10', 'pointer-events-none');
            footer?.classList.add('animate-fade-in-up-75');
            html?.classList.remove('cta-open');
            this.open = false;
        }
        else {
            footer?.classList.add('animate-fade-out-down-10', 'pointer-events-none');
            footer?.classList.remove('animate-fade-in-up-75');
            this.content.classList.remove('animate-fade-out-down-10', 'pointer-events-none');
            this.content.classList.add('animate-fade-in-up-25');
            html?.classList.add('cta-open');
            this.open = true;
        }
    }
}
